import React, { use, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import allTeams from '../../data/teams';
import { Chart as ChartJS } from "chart.js/auto"; // Tout est déjà enregistré
import PointPerPlayer from "../../component/game/PointPerPlayer";

interface StarPlayerProps {
    game: any; // Replace `any` with the actual type for `game`
    homeTeam: any; // Replace `any` with the actual type for `homeTeam`
    awayTeam: any; // Replace `any` with the actual type for `awayTeam`
}

interface PlayerInfo {
    teamId: number;
    playerId: number;
    firstName: {
        default: string;
    };
    lastName: {
        default: string;
    };
    sweaterNumber: number;
    positionCode: string;
    headshot: string;
}

interface Player {
    id: number;
    actionCount: number;
    typeDescKey: string;
    playerInfo: PlayerInfo;
}

const StarPlayer: React.FC<StarPlayerProps>  = ({ game, homeTeam, awayTeam }) => {

    const [ playerWithPoints, setPlayerWithPoints ] = useState<Player[]>([]);
    const [ faceoffWins, setFaceoffWins ] = useState<Player[]>([]);
    const [ playerWithGoal, setPlayerWithGoal ] = useState<Player[]>([]);
    const [ playerWithMostHit, setPlayerWithMostHit ] = useState<Player[]>([]);
    const [ playerWithMostShot, setPlayerWithMostShot ] = useState<Player[]>([]);
    const [ playerWithMostBlock, setPlayerWithMostBlock ] = useState<Player[]>([]);
    const [ playerWithSaves, setPlayerWithSaves ] = useState<Player[]>([]);
    
    const gamePlays = game?.plays || [];
    const typeDescKeys = Array.from(new Set(gamePlays.map((item) => item.typeDescKey)));

    function getPlayerInfo (playerId: number) {
        const player = game.rosterSpots.find((spot: any) => spot.playerId === playerId);
        return player ? player : null;
    }
    

    function processPlays(plays: any[], action: string, selected?: string): Player[] {
    
        const playersMap: Map<number, Player> = new Map(); // Use a Map for efficient lookups


        plays.forEach((play: any) => {
            if (play.typeDescKey === action) {
                // Determine the player ID from the play object
                let playerId;

                switch (action) {
                  case 'shot-on-goal':
                    if (selected === 'goalieInNetId') {
                        playerId = play.details?.goalieInNetId;
                    }
                    else {
                        playerId = play.details?.shootingPlayerId;
                    }
                    break;
                    
                  case 'goal':                    
                  if (selected === 'goalieInNetId') {
                    playerId = play.details?.assist2PlayerId ||                    
                    play.details?.assist1PlayerId;
                }
                else {
                    playerId = play.details?.scoringPlayerId;                    
                }
                    break;
                
                  case 'faceoff':
                    playerId = play.details?.winningPlayerId;
                    break;
                
                  case 'hit':
                    playerId = play.details?.hittingPlayerId;
                    break;
                
                  case 'blocked-shot':
                    playerId = play.details?.blockingPlayerId;
                    break;    

                  default:
                    playerId = null;
                    break;
                }


                // const playerId =
                //     play.details?.shootingPlayerId ||
                //     play.details?.scoringPlayerId ||
                //     play.details?.goalieInNetId ||
                //     play.details?.winningPlayerId ||
                //     play.details?.hittingPlayerId ||
                //     play.details?.assist1PlayerId ||
                //     play.details?.assist2PlayerId ;

                const playerInfo = getPlayerInfo(playerId);

                if (playerId) {
                    // Check if the player already exists in the playersMap
                    if (playersMap.has(playerId)) {
                        // Increment the actionCount for the existing player
                        const existingPlayer = playersMap.get(playerId);
                        if (existingPlayer) {
                            existingPlayer.actionCount++;
                            playersMap.set(playerId, existingPlayer); // Update the Map
                        }
                    } else {
                        // Add a new player to the playersMap
                        getPlayerInfo(playerId); // Fetch player info (not used here but could be useful)
                        playersMap.set(playerId, {
                            id: playerId,
                            actionCount: 1,
                            typeDescKey: action+selected,
                            playerInfo: playerInfo
                        });
                    }
                }
            }
        });
    
        // Convert the Map to an array for the final result
        const playersList = Array.from(playersMap.values());
        return playersList; // Return the updated players list
    }
    const getActionLabel = (typeDescKey: string): string => {
        switch (typeDescKey) {
            case "goal":
                return "Goal";
            case "shot-on-goal":
                return "Shot";
            case "faceoff":
                return "faceoff win";
            case "hit":
                return "Hits Made";
            }
    };


function getThePlayerWithMostAction(players: Player[]) {
    if (players.length === 0) return null;
    const playerStar = players.reduce((max, player) => player.actionCount > max.actionCount ? player : max);
    const amountAction = players.reduce((max, player) => player.actionCount > max.actionCount ? player : max).actionCount
    const playerLayout = (
        <Link to={`/player/${playerStar.id}`}>
        <div>
            <div className="headshot">
            <img 
                src={playerStar.playerInfo.headshot} 
                alt={`${playerStar.playerInfo.firstName.default} ${playerStar.playerInfo.lastName.default}`} 
                style={{ width: "110px", height: "110px" }}
            />
            </div>
            <p>{playerStar.playerInfo.firstName.default} {playerStar.playerInfo.lastName.default}</p>
            <p><strong>{amountAction} {getActionLabel(playerStar.typeDescKey)}</strong></p>
        </div>
        </Link>
    );

    return playerLayout;

}

useEffect(() => {
    if (game?.plays) {
        
        setPlayerWithSaves(processPlays(game.plays, 'shot-on-goal', 'goalieInNetId'));       
        setPlayerWithPoints(processPlays(game.plays, 'goal', 'goalieInNetId'));
        setPlayerWithMostShot(processPlays(game.plays, 'shot-on-goal'));
        setPlayerWithGoal(processPlays(game.plays, 'goal'));
        setPlayerWithMostHit(processPlays(game.plays, 'hit'));
        setFaceoffWins(processPlays(game.plays, 'faceoff'));
        setPlayerWithMostBlock(processPlays(game.plays, 'blocked-shot'));
        
    } else {
        console.error("Game plays data is undefined or null:", game);
    }

}, [game, homeTeam, awayTeam]);

    return (
    <div className="teamContent">
        <div className="title">Star Players</div>
        <div className="starPlayersWrapper">
            <div className="starPlayer">
                <h3>Most Saves</h3>
                { getThePlayerWithMostAction(playerWithSaves) }
            </div>
            <div className="starPlayer">
                <h3>Most Faceoff</h3>
                { getThePlayerWithMostAction(faceoffWins) }
            </div>

            <div className="starPlayer">
                <h3>Most Shots</h3>
                { getThePlayerWithMostAction(playerWithMostShot) }
            </div>
            <div className="starPlayer">
                <h3>Most Hits</h3>
                { getThePlayerWithMostAction(playerWithMostHit) }
            </div>
            <div className="starPlayer">
                <h3>Most Blocks</h3>
                { getThePlayerWithMostAction(playerWithMostBlock) }
            </div>
           <PointPerPlayer game={game} homeTeam={homeTeam} awayTeam={awayTeam} />
            </div>
          
    </div> );
}

export default StarPlayer;
